/**
 * Assigned workouts (client view) – list by schedule day.
 */
import { collection, query, where, orderBy, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'assignedWorkouts';

export async function listByScheduleDay(scheduleDayId, clientId) {
  if (!scheduleDayId || !clientId) throw new Error('scheduleDayId and clientId are required');
  const q = query(
    collection(db, COLLECTION),
    where('scheduleDayId', '==', scheduleDayId),
    where('clientId', '==', clientId),
    orderBy('order', 'asc'),
    limit(50)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export const assignedWorkoutRepo = { listByScheduleDay };
